import { ListWrapper } from '@react/ListWrapper'
import { initReactInAuthorMode } from '@react/react-author-mode'
import { registerReactComponent } from '@react/register-react-component'

registerReactComponent('ListWrapper', ListWrapper)
initReactInAuthorMode({ component: ListWrapper, componentName: 'ListWrapper' })
